import { render, staticRenderFns } from "./ClearProject.vue?vue&type=template&id=4aa367cd&lang=pug&"
import script from "./ClearProject.vue?vue&type=script&lang=js&"
export * from "./ClearProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports